import {
  Avatar,
  Box,
  CircularProgress,
  IconButton,
  Stack,
  Typography,
} from "@mui/material";
import { DamsAppAsset } from "../../assets/registry";

import { DamsColors } from "../styles/DamsColors";
import SimpleLabel from "../Label";
import { grey } from "@mui/material/colors";

interface Props {
  label?: string;
  placeholder?: string;
  size?: "short" | "long" | "full";
  handleChange?: () => void;
  name?: string;
  value?: string | number;
  error?: boolean;
  errorMessage?: string;
  loading?: boolean;
  height?: "small" | "normal";
  required?: boolean;
}
export function CustomInputButton({
  size = "short",
  label,
  placeholder,
  handleChange,
  value,
  error,
  errorMessage,
  loading,
  height = "normal",
  required = false,
}: Readonly<Props>) {
  const handleToggle = () => {
    if (!loading) {
      if (handleChange) handleChange();
    }
  };

  const isnormal = height === "normal";
  const InputSize =
    size === "long"
      ? { width: 512, height: isnormal ? 80 : 45 }
      : size === "full"
      ? { width: "100%", height: isnormal ? 80 : 45 }
      : { width: 260, height: isnormal ? 80 : 45 };

  return (
    <Stack
      width={InputSize.width}
      height={InputSize.height}
      gap={isnormal ? 0.3 : -1}
    >
      <Typography
        fontFamily={"Inter"}
        fontWeight={isnormal ? 500 : 400}
        fontSize={isnormal ? 14 : 12}
        color={isnormal ? DamsColors.Text.PageLabel : "#667085"}
      >
        {label}
        {required && <span style={{ color: "red", marginLeft: "4px" }}>*</span>}
      </Typography>

      <Box sx={styles.field} onClick={handleToggle}>
        {value ? (
          <SimpleLabel width={"100%"} title={value?.toString()} />
        ) : (
          <SimpleLabel
            width={"100%"}
            sx={{ color: grey[400], fontWeight: "400" }}
            title={placeholder}
          />
        )}

        <IconButton onClick={handleToggle}>
          {loading ? (
            <CircularProgress size={15} />
          ) : (
            <Avatar
              src={DamsAppAsset.icons.select_arrow}
              sx={styles.arrowDownIcon}
            />
          )}
        </IconButton>
      </Box>

      {error && (
        <Typography variant="caption" color={"red"} sx={{ marginLeft: 1 }}>
          {errorMessage}
        </Typography>
      )}
    </Stack>
  );
}

const styles = {
  arrowDownIcon: {
    width: "20px",
    height: "20px",
  },

  field: {
    borderWidth: 1,
    borderStyle: "solid",
    borderRadius: "8px",
    borderColor: `${DamsColors.Border.PageInput} !important`,
    width: "100%",
    display: "flex",
    flexDirection: "row",
    backgroundColor: "transparent",
    height: 75,
    alignItems: "center",
    justifyContent: "space-between",
    paddingX: 1.2,
  },
};

export default CustomInputButton;
